(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faculty"] && !Shopify.designMode) return;
  try {
    
  class SrfFacultySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.srf-faculty__track');
      this.dotsWrap = this.querySelector('.srf-faculty__pagination');
      if (!this.track || !this.dotsWrap) return;

      this.cards = Array.from(this.track.children);
      this.perPage = 1;

      this.isDown = false;
      this.didDrag = false;
      this.startX = 0;
      this.scrollLeftStart = 0;

      this.applyResponsivePerPage();
      this.buildDots();
      this.bindDrag();
      this.bindScrollSync();

      window.addEventListener('resize', () => {
        this.applyResponsivePerPage();
        this.buildDots();
        this.updateActiveDot();
      });
    }

    applyResponsivePerPage() {
      this.perPage = window.innerWidth < 769 ? 1 : 4;
      this.style.setProperty('--srf-per-page', this.perPage);
    }

    get totalPages() {
      return Math.max(1, Math.ceil(this.cards.length / this.perPage));
    }

    buildDots() {
      this.dotsWrap.innerHTML = '';
      const pages = this.totalPages;
      if (pages <= 1) return;

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'srf-faculty__dot';
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToPage(i));
        this.dotsWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    scrollToPage(pageIndex) {
      const targetCard = this.cards[pageIndex * this.perPage];
      if (!targetCard) return;
      this.track.scrollTo({
        left: targetCard.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }

    bindScrollSync() {
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.updateActiveDot();
          ticking = false;
        });
      });
    }

    updateActiveDot() {
      const dots = this.dotsWrap.querySelectorAll('.srf-faculty__dot');
      if (!dots.length || !this.cards.length) return;

      const scrollPos = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDist = Infinity;

      this.cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - this.track.offsetLeft - scrollPos);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });

      const activePage = Math.round(closestIndex / this.perPage);

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activePage));
    }

    bindDrag() {
      const track = this.track;

      // Mouse drag (desktop) — native-feeling, no resistance
      track.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.didDrag = false;
        track.classList.add('is-dragging');
        this.startX = e.pageX;
        this.scrollLeftStart = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
        setTimeout(() => { this.didDrag = false; }, 50);
      });

      track.addEventListener('mouseleave', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        const walk = e.pageX - this.startX;
        if (Math.abs(walk) > 5) this.didDrag = true;
        track.scrollLeft = this.scrollLeftStart - walk;
      });

      // Touch (mobile) - rely mostly on native scroll, just track drag flag
      track.addEventListener('touchstart', (e) => {
        this.didDrag = false;
        this.touchStartX = e.touches[0].pageX;
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        if (Math.abs(e.touches[0].pageX - this.touchStartX) > 5) {
          this.didDrag = true;
        }
      }, { passive: true });
    }
  }

  customElements.define('srf-faculty-slider', SrfFacultySlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-icons"] && !Shopify.designMode) return;
  try {
    
  class WyaaFeatureSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wyaa-features__track');
      this.dotsWrap = this.querySelector('.wyaa-features__dots');
      if (!this.track || !this.dotsWrap) return;

      this.dots = [];
      this.isDown = false;
      this.startX = 0;
      this.scrollLeftStart = 0;

      this.buildDots();
      this.bindDrag();

      this.track.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => this.updateActiveDot());
      });

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.buildDots(), 150);
      });
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    getItems() {
      return Array.from(this.track.children).filter((el) =>
        el.classList.contains('wyaa-features__item')
      );
    }

    buildDots() {
      this.dotsWrap.innerHTML = '';
      this.dots = [];

      if (!this.isMobile()) return;

      const items = this.getItems();
      items.forEach((item, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wyaa-features__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
        this.dots.push(dot);
      });
      this.updateActiveDot();
    }

    updateActiveDot() {
      if (!this.dots.length) return;
      const items = this.getItems();
      const scrollLeft = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDist = Infinity;

      items.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - this.track.offsetLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }

    bindDrag() {
      const track = this.track;

      track.addEventListener('mousedown', (e) => {
        if (!this.isMobile()) return;
        this.isDown = true;
        track.classList.add('is-dragging');
        this.startX = e.pageX - track.offsetLeft;
        this.scrollLeftStart = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mouseleave', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = x - this.startX;
        track.scrollLeft = this.scrollLeftStart - walk;
      });
    }
  }

  customElements.define('wyaa-feature-slider', WyaaFeatureSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["student-testimonials"] && !Shopify.designMode) return;
  try {
    
  class SrfTestimonialSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.srf-testimonial__track');
      this.dotsWrap = this.querySelector('.srf-testimonial__pagination');
      if (!this.track || !this.dotsWrap) return;

      this.cards = Array.from(this.track.children);
      this.perPage = 1;

      this.isDown = false;
      this.didDrag = false;
      this.startX = 0;
      this.scrollLeftStart = 0;

      this.applyResponsivePerPage();
      this.buildDots();
      this.bindDrag();
      this.bindScrollSync();

      window.addEventListener('resize', () => {
        this.applyResponsivePerPage();
        this.buildDots();
        this.updateActiveDot();
      });
    }

    applyResponsivePerPage() {
      const desktopPerPage = parseInt(this.dataset.perPage, 10) || 3;
      this.perPage = window.innerWidth < 769 ? 1 : desktopPerPage;
      this.style.setProperty('--srf-per-page', this.perPage);
    }

    get totalPages() {
      return Math.max(1, Math.ceil(this.cards.length / this.perPage));
    }

    buildDots() {
      this.dotsWrap.innerHTML = '';
      const pages = this.totalPages;
      if (pages <= 1) return;

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'srf-testimonial__dot';
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToPage(i));
        this.dotsWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    scrollToPage(pageIndex) {
      const targetCard = this.cards[pageIndex * this.perPage];
      if (!targetCard) return;
      this.track.scrollTo({
        left: targetCard.offsetLeft - this.track.offsetLeft,
        behavior: 'smooth'
      });
    }

    bindScrollSync() {
      let ticking = false;
      this.track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.updateActiveDot();
          ticking = false;
        });
      });
    }

    updateActiveDot() {
      const dots = this.dotsWrap.querySelectorAll('.srf-testimonial__dot');
      if (!dots.length || !this.cards.length) return;

      const scrollPos = this.track.scrollLeft;
      let closestIndex = 0;
      let closestDist = Infinity;

      this.cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - this.track.offsetLeft - scrollPos);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = i;
        }
      });

      const activePage = Math.round(closestIndex / this.perPage);

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activePage));
    }

    bindDrag() {
      const track = this.track;

      // Mouse drag (desktop) — native-feeling, no resistance
      track.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.didDrag = false;
        track.classList.add('is-dragging');
        this.startX = e.pageX;
        this.scrollLeftStart = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
        setTimeout(() => { this.didDrag = false; }, 50);
      });

      track.addEventListener('mouseleave', () => {
        if (!this.isDown) return;
        this.isDown = false;
        track.classList.remove('is-dragging');
      });

      track.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        const walk = e.pageX - this.startX;
        if (Math.abs(walk) > 5) this.didDrag = true;
        track.scrollLeft = this.scrollLeftStart - walk;
      });

      // Touch (mobile) - rely mostly on native scroll, just track drag flag
      track.addEventListener('touchstart', (e) => {
        this.didDrag = false;
        this.touchStartX = e.touches[0].pageX;
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        if (Math.abs(e.touches[0].pageX - this.touchStartX) > 5) {
          this.didDrag = true;
        }
      }, { passive: true });
    }
  }

  customElements.define('srf-testimonial-slider', SrfTestimonialSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  class VideoTestimonialGrid extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.srf-vidtest__grid');
      this.paginationWrap = this.querySelector('.srf-vidtest__pagination');
      this.slides = Array.from(this.querySelectorAll('.srf-vidtest__slide'));
      this.perPage = parseInt(this.dataset.perPage, 10) || 3;

      this.isDown = false;
      this.didDrag = false;
      this.startX = 0;
      this.scrollLeftStart = 0;

      this.applyResponsivePerPage();
      this.buildDots();
      this.bindDrag();
      this.bindScrollSync();

      this.querySelectorAll('.srf-vidtest__play').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          if (this.didDrag) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          this.playVideo(btn);
        });
      });

      window.addEventListener('resize', () => {
        this.applyResponsivePerPage();
        this.buildDots();
        this.updateActiveDot();
      });
    }

    applyResponsivePerPage() {
      const basePerPage = parseInt(this.dataset.perPage, 10) || 3;
      this.perPage = window.innerWidth < 769 ? 1 : basePerPage;
      this.style.setProperty('--srf-per-page', this.perPage);
    }

    get totalPages() {
      return Math.max(1, Math.ceil(this.slides.length / this.perPage));
    }

    buildDots() {
      this.paginationWrap.innerHTML = '';
      const pages = this.totalPages;
      if (pages <= 1) return;

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'srf-vidtest__dot';
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToPage(i));
        this.paginationWrap.appendChild(dot);
      }
      this.updateActiveDot();
    }

    scrollToPage(pageIndex) {
      const targetSlide = this.slides[pageIndex * this.perPage];
      if (!targetSlide) return;
      this.grid.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });
    }

    bindScrollSync() {
      let ticking = false;
      this.grid.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.updateActiveDot();
          ticking = false;
        });
      });
    }

    updateActiveDot() {
      const dots = this.paginationWrap.querySelectorAll('.srf-vidtest__dot');
      if (!dots.length || !this.slides.length) return;

      const scrollPos = this.grid.scrollLeft;
      let closestIndex = 0;
      let closestDiff = Infinity;
      this.slides.forEach((slide, i) => {
        const diff = Math.abs(slide.offsetLeft - scrollPos);
        if (diff < closestDiff) {
          closestDiff = diff;
          closestIndex = i;
        }
      });

      const activePage = Math.round(closestIndex / this.perPage);

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activePage);
      });
    }

    bindDrag() {
      const grid = this.grid;

      // Mouse drag (desktop) — native-feeling, no resistance
      grid.addEventListener('mousedown', (e) => {
        this.isDown = true;
        this.didDrag = false;
        grid.classList.add('is-dragging');
        this.startX = e.pageX;
        this.scrollLeftStart = grid.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (!this.isDown) return;
        this.isDown = false;
        grid.classList.remove('is-dragging');
        // Reset didDrag shortly after, so the click handler can still see it during this tick
        setTimeout(() => { this.didDrag = false; }, 50);
      });

      grid.addEventListener('mouseleave', () => {
        if (!this.isDown) return;
        this.isDown = false;
        grid.classList.remove('is-dragging');
      });

      grid.addEventListener('mousemove', (e) => {
        if (!this.isDown) return;
        const walk = e.pageX - this.startX;
        if (Math.abs(walk) > 5) this.didDrag = true;
        grid.scrollLeft = this.scrollLeftStart - walk;
      });

      // Touch (mobile) - rely mostly on native scroll, just track drag flag
      // so a tap-vs-swipe can be distinguished for the play button.
      grid.addEventListener('touchstart', (e) => {
        this.didDrag = false;
        this.touchStartX = e.touches[0].pageX;
      }, { passive: true });

      grid.addEventListener('touchmove', (e) => {
        if (Math.abs(e.touches[0].pageX - this.touchStartX) > 5) {
          this.didDrag = true;
        }
      }, { passive: true });
    }

    playVideo(btn) {
      const media = btn.closest('.srf-vidtest__media');
      if (!media) return;

      this.stopOtherVideos(media);

      const embed = media.querySelector('.srf-vidtest__embed');
      if (embed) {
        const src = embed.dataset.embedSrc;
        if (src) {
          if (!embed.dataset.originalHtml) {
            embed.dataset.originalHtml = embed.innerHTML;
          }
          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          embed.innerHTML = '';
          embed.appendChild(iframe);
          media.classList.add('is-playing');
        }
        return;
      }

      const video = media.querySelector('video');
      if (!video) return;
      media.classList.add('is-playing');
      video.muted = false;
      video.controls = true;
      video.play();
    }

    stopOtherVideos(activeMedia) {
      this.querySelectorAll('.srf-vidtest__media').forEach((media) => {
        if (media === activeMedia) return;
        this.resetMedia(media);
      });
    }

    resetMedia(media) {
      if (!media.classList.contains('is-playing')) return;

      const embed = media.querySelector('.srf-vidtest__embed');
      if (embed) {
        if (embed.dataset.originalHtml) {
          embed.innerHTML = embed.dataset.originalHtml;
        } else {
          const iframe = embed.querySelector('iframe');
          if (iframe) iframe.remove();
        }
        media.classList.remove('is-playing');
        return;
      }

      const video = media.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
        video.controls = false;
      }
      media.classList.remove('is-playing');
    }
  }

  customElements.define('video-testimonial-grid', VideoTestimonialGrid);

  } catch(e) { console.error(e); }
})();
})();
